import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStar = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.99975 11.1403L10.1122 13.0228C10.6822 13.3678 11.3797 12.8578 11.2297 12.2128L10.4047 8.67281L13.1572 6.28781C13.6597 5.85281 13.3897 5.02781 12.7297 4.97531L9.10725 4.66781L7.68975 1.32281C7.43475 0.715313 6.56475 0.715313 6.30975 1.32281L4.89225 4.66031L1.26975 4.96781C0.609749 5.02031 0.339749 5.84531 0.842249 6.28031L3.59475 8.66531L2.76975 12.2053C2.61975 12.8503 3.31725 13.3603 3.88725 13.0153L6.99975 11.1403Z",
		fill: "#3C59F6"
	})
});
export default SvgStar;
